import styled from "styled-components"
import { RoundedBox } from "components/box"

const BorderBox = styled(RoundedBox)`
  display: flex;
  justify-content: center;
  text-align: center;

  background-color: ${props => props.theme.colors.white};
  border-color: ${props => props.theme.colors.lightGrey};
`

export default BorderBox
